import React from 'react';
import {vehiclesInventoryScreens} from '../constants';
import Header from './internalCommons/header';
import InventoryByModel from './main';

const VehiclesInventory = () => {
  return <>
    <Header screen={vehiclesInventoryScreens.main} />
    <InventoryByModel />
  </>;
};

export default VehiclesInventory;
